import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueFlashMessage from 'vue-flash-message'

import _ from 'underscore'

import api from 'plugins/api.vue'
import store from 'plugins/store.vue'

import home from 'pages/home.vue'
import login from 'pages/login.vue'
import signup from 'pages/signup.vue'
import signupComplete from 'pages/signup-complete.vue'
import confirmEmail from 'pages/confirm-email.vue'
import match from 'pages/match.vue'
import score from 'pages/score.vue'
import tournaments from 'pages/tournaments.vue'
import tournamentRename from 'pages/tournament-rename.vue'
import tournamentDetail from 'pages/tournament-detail.vue'
import profile from 'pages/profile.vue'
import profileEdit from 'pages/profile-edit.vue'
import changePassword from 'pages/change-password.vue'
import stats from 'pages/stats.vue'
import ranking from 'pages/ranking.vue'
import activity from 'pages/activity.vue'
import post from 'pages/post.vue'
import conversations from 'pages/conversations.vue'
import conversation from 'pages/conversation.vue'
import conversationNew from 'pages/conversation-new.vue'
import notificationArchive from 'pages/notification-archive.vue'
import friendList from 'pages/friend-list.vue'

import axios from 'axios'
import linkify from 'vue-linkify'

Vue.use(VueFlashMessage, { messageOptions: {
    timeout: 2000,
    pauseOnInteract: true,
    createShortcuts: false
} })
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.directive('linkified', linkify)

window.API_ENDPOINT = '/'
Vue.use(api)

window.store = store

window.router = new VueRouter({
    routes: [
        { path: '/', component: home },
        { path: '/login', component: login, meta: { public: true } },
        { path: '/signup', component: signup, meta: { public: true } },
        { path: '/signup-complete', component: signupComplete, meta: { public: true } },
        { path: '/confirm-email/:token', component: confirmEmail, meta: { public: true } },
        { path: '/create-match', component: match },
        { path: '/tournaments', component: tournaments },
        { path: '/tournament/:id/rename', component: tournamentRename },
        { path: '/tournament/:id', component: tournamentDetail },
        { path: '/match/:id', name: 'submit-score', component: score },
        { path: '/profile/edit', component: profileEdit },
        { path: '/profile/:id/stats', component: stats },
        { path: '/profile/:id/friends', component: friendList },
        { path: '/profile/change-password', component: changePassword },
        { path: '/profile/:id', component: profile },
        { path: '/users/:user/ranking/:type', component: ranking },
        { path: '/post', component: post },
        { path: '/timeline/:id', component: activity },
        { path: '/conversations/new', component: conversationNew },
        { path: '/conversations/:id', component: conversation },
        { path: '/conversations', component: conversations },
        { path: '/notifications', component: notificationArchive }
    ]
})

window.router.beforeEach((to, from, next) => {
    // Change layout for conversation page, so that message input field can be pinned to bottom
    if (/^\/conversations\//.test(to.path)) {
        document.body.className = 'fixed-layout'
    } else {
        document.body.className = ''
    }

    if (to.matched.some(record => !record.meta.public) && !window.store.state.loggedIn) {
        next('/login')
    } else if (to.matched.every(record => record.meta.public) && window.store.state.loggedIn) {
        next('/')
    } else {
        next()
    }
})

var app = new Vue({
    router: window.router,
    store: window.store,
    data () {
        return {
            newMessages: false
        }
    },
    computed: {
        user () {
            return window.store.state.user
        }
    },
    beforeMount () {
        // Workaround: make flash plugin globally accessible for api plugin
        window.flash = this.flash

        // Checks if any new messages are present, if the user is logged in
        function checkMessages (repeat) {
            if (!window.store.state.loggedIn) {
                app.newMessages = false

                if (repeat) {
                    setTimeout(() => checkMessages(true), 10000)
                }

                return
            }

            app.$api.get('conversations/check')
            .then(response => {
                app.newMessages = response.data.new_messages
            })
            .finally(() => {
                if (repeat) {
                    setTimeout(() => checkMessages(true), 10000)
                }
            })
        }

        // Begin checking messages every 5s
        checkMessages(true)

        // Also check messages after user logged in
        window.store.subscribe((mutation, state) => {
            if (mutation.type == 'login') {
                checkMessages(false)
            }
        })
    }
})

app.$mount('#master')



// WEBPACK FOOTER //
// ./src/main.js